import { create } from "zustand";
import { persist } from "zustand/middleware";

interface TyPermission {
    store: string;
    model: string;
    actions: string[];
    branches: string[] | "all";
}

interface TyClient {
    _id: string;
    name: string;
    phone: string;
    email?: string;
    picture?: string;
    birthDate?: string;
    gender?: string;
    owner: any[];
    permissions: TyPermission[];
}

interface AuthState {
    token: string | null;
    client: TyClient | null;
    setAuth: (token: string, client: TyClient) => void;
    updatePermissions: (storeId: string, permissions: TyPermission[]) => void;
    clearAuth: () => void;
}

const useAuthStore = create<AuthState>()(
    persist(
        (set, get) => ({
            token: null,
            client: null,
            setAuth: (token, client) => set({ token, client }),
            updatePermissions: (storeId, permissions) => {
                const client = get().client;
                if (!client) return;
                const updated = client.permissions.map((p) => (p.store === storeId ? { ...p, ...permissions } : p));
                set({ client: { ...client, permissions: updated } });
            },
            clearAuth: () => set({ token: null, client: null }),
        }),
        { name: "auth" }
    )
);

export default useAuthStore;
